import ControlModule               from 'scripts/poppet/control-module';
import template                    from './controlHomeAlertsView.jst.html';
import ControlTemperatureAlertView from './temperature-alert/view-control-temperature-alert-view';
import ControlBatteryAlertView     from './battery-alert/view-control-battery-alert-view';
import ControlPowerAlertView       from './power-alert/view-control-power-alert-view';

const selectors = {
	temperatureAlert: '[data-region=temperature-alert]',
	batteryAlert    : '[data-region=battery-alert]',
	powerAlert      : '[data-region=power-alert]',
	closeButton     : '[data-click=homeAlerts-close]'
};

export const ControlHomeAlertView = ControlModule.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template : template,
	
	ui: {
		close : selectors.closeButton,
	},
	
	events: {
		'click @ui.close'  : 'onClickClose'
	},
	
	regions: {
		temperatureAlert: selectors.temperatureAlert,
		batteryAlert    : selectors.batteryAlert,
		powerAlert      : selectors.powerAlert,
	},
	
	className: function () {
		return this._getClassName( 'control-home-alerts' );
	},
	
	onClickClose: function(){
		this.trigger('close', this)
	},
	
	onDomRefresh() {
		let temperatureAlertView = new ControlTemperatureAlertView( _.extend( this.options, {
			model: this.model.temperatureModel,
		}));
		this.showChildView( 'temperatureAlert', temperatureAlertView );
		
		let batteryAlertView = new ControlBatteryAlertView( _.extend( this.options, {
			model: this.model.batteryModel,
		}));
		this.showChildView( 'batteryAlert', batteryAlertView );
		
		let powerAlertView = new ControlPowerAlertView( _.extend( this.options, {
			model: this.model.powerModel,
		}));
		this.showChildView( 'powerAlert', powerAlertView );
	},
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
});

export default  ControlHomeAlertView;
